import PageNotFound from "../assets/pageNotFound.svg";
import Footer from "../components/Footer";

function NotFound() {
  return (
    <div className="">
      <div className="bg-[#0f172a] flex flex-col items-center gap-3 h-[470px]">
        <div className="mt-[100px]">
          <img src={PageNotFound} alt="" className="w-[100px] h-[100px]" />
        </div>

        <div className="text-3xl text-[#94a3b8]">Page NotFound</div>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
